import configPromise from './config';

// Add Ambit styles to the page
configPromise.then(config => {
  const style = document.createElement('style');
  const { chatWindowZIndex = '999999', launcherZIndex = 'auto', dimensions } = config;

  const laucherHeight = 90;

  const panelHeightInt = Number(dimensions.panelHeight.replace('px', ''));

  style.innerHTML = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');
  
  #ambitChatWindow {
    width: 100%;
    height: 100%;
    
    position: fixed; 
    bottom: 0;
    right: 0;
    
    z-index: ${chatWindowZIndex};
    border: 0;
    
    transition: transform 0.25s ease-out;
    transform-origin: calc(100% - 45px) calc(100% - 45px);
  }

  @media screen and (max-height: ${panelHeightInt + laucherHeight}px) and (min-width: 768px) {
    #ambitChatWindow {
      width: ${dimensions.panelWidth};
      bottom: 0;
      right: 0;
    }
  }

  @media screen and (min-height: ${panelHeightInt + laucherHeight}px) and (min-width: 768px) {
    #ambitChatWindow {
      height: ${dimensions.panelHeight};
      width: ${dimensions.panelWidth};
       
      ${dimensions.panelPosition}
    }
  }
  
  #ambitChatWindow.ambitOpen {
    transform: scale(1);
  }
  
  #ambitChatWindow.ambitClosed {
    transform: scale(0);
  }
  
  #ambitLauncher {
    border: 0;
    width: 90px;
    height: 90px;
  }
  
  #ambitLauncherWrapper {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: ${launcherZIndex};
    height: 90px;
    width: 90px;
  }
  
  #ambitTooltip {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    padding: 12px;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 2px 2px rgba(0,0,0,0.05);
    z-index: ${launcherZIndex};
    position: relative;
  }
  
  #ambitTooltipContainer {
    display: none;
    position: absolute;
    height: 90px;
    right: 90px;
    bottom: 0;
    align-items: center;
    justify-content: flex-end;
    width: 400px;
  }
  
  .ambitShowTooltip #ambitTooltipContainer {
    display: flex;
  }
  
  #ambitTooltipTriangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7.5px 0 7.5px 11px;
    border-color: transparent transparent transparent #ffffff;
    
    position: absolute;
    right: -10px;
    top: 14px;
  }
  
  #ambitInlineChatWindow {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;
  document.body.appendChild(style);
});



// WEBPACK FOOTER //
// ./src/initialiser/css.js